module.exports = __webpack_public_path__ + "img/loupe.7bc9181b.png";